import { useQuery } from '@tanstack/react-query';
import { useRequest } from '~/lib/useRequest';
import { ProgramsPagePropsHttpResponse } from '@ab/ams-school-api/types/private/v1';
import { config } from '~/config';
import { hasKey } from '~/utils';

export type FieldOfStudyOption = {
  label: string;
  value: string;
};

export function useFieldsOfStudy() {
  const request = useRequest();

  const { isLoading, isFetching, error, data, isError } = useQuery({
    queryKey: ['fieldsOfStudy'],
    queryFn: async () => {
      const response = await request<ProgramsPagePropsHttpResponse['body']>(
        `${config.apiHost}/private/v1/programs/page_props`,
        {
          method: 'GET',
          isExpectedResponse,
        }
      );

      const fieldsOfStudy = response.referenceData.fieldsOfStudy || {};
      return fieldsOfStudy;
    },
  });

  return {
    isLoadingFieldsOfStudy: isLoading,
    isFetchingFieldsOfStudy: isFetching,
    fieldsOfStudyError: error,
    fieldsOfStudyData: data || {},
    isFieldsOfStudyError: isError,
  };
}

function isExpectedResponse(res: unknown): res is ProgramsPagePropsHttpResponse['body'] {
  return Boolean(res && typeof res === 'object' && hasKey('referenceData', res));
}
